import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';

import { Router, ActivatedRoute } from '@angular/router';
import { HttpHeaders } from '@angular/common/http';
import { HttpClient } from '@angular/common/http';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';

import { NbWindowService, NbDialogService } from '@nebular/theme';
//import { WindowFormComponent } from '../window-form/window-form.component';
import { NbSortDirection, NbSortRequest, NbTreeGridDataSource, NbTreeGridDataSourceBuilder } from '@nebular/theme';

import { NbDateService } from '@nebular/theme';

import { CookieService } from 'ngx-cookie-service';
import { SubscriptService } from '../../../tool/service/header.service';
import * as XLSX from 'xlsx';


@Component({
  selector: 'user-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  routingName: string = 'user';
  apiURL: string;
  user: user = new user();

  searchkey: string
  page = 1
  comList = []

  loadingSpiner: boolean = false ;





  constructor(private http: HttpClient,
    private cookieService: CookieService,
    private hs: SubscriptService,
    private _router: Router,
  ) {
   
  }
  //頁面初始化
  ngOnInit() {
    this.cookieService.delete('USR_AccountInfo_ID','/');
    this.cookieService.delete('USR_EmployeeInfo_ID','/');
    this.cookieService.delete('NickName','/');
    this.cookieService.delete('PhotoURL','/');
    this.cookieService.delete('ORG_Company_ID','/');
    this.cookieService.delete('ORG_Store_ID','/');
    this.cookieService.delete('CompanyName','/');
    this.cookieService.delete('USR_POSEmployeeInfo_ID','/');

  }

  goto_login(){
    
    this.loadingSpiner = true;
    
    if(this.user.loginType == '1'){
      this.getCom()
    }
    else{
      this.login(null)
    }
  }



  //取列表資料
  getCom() {

    this.user.Password = this.user.Password.trim()
    this.http.post<any>('api/Login/LoginCom', this.user).subscribe({
      next: data => {
        if (data.RESULT) {
          alert(data.RESULT);
        } else {
         this.comList = data.LIST
         this.page = 2 
        }
        //2024.02.20 新增登入的loading介面
        this.loadingSpiner = false;
      },
      error: error => {
        console.error('There was an error!', error);
        //2024.02.20 新增登入的loading介面
        this.loadingSpiner = false;
      }
    })
  }




  //登入
  login(code) {

    this.loadingSpiner = true;

    this.user.CompanyCode = code

    this.user.Password = this.user.Password.trim()

    this.http.post<any>('api/Login/Post', this.user).subscribe({
      next: data => {
        if (data.RESULT) {
          alert(data.RESULT);
        } else {
          console.log('QAQ')
          this.cookieService.delete('USR_AccountInfo_ID');
          this.cookieService.delete('USR_EmployeeInfo_ID');
          this.cookieService.delete('NickName');
          this.cookieService.delete('PhotoURL');
          this.cookieService.delete('ORG_Company_ID');
          this.cookieService.delete('CompanyName');
          this.cookieService.delete('USR_POSEmployeeInfo_ID');

          this.cookieService.set('USR_AccountInfo_ID', data.USR_AccountInfo_ID,1,'/');
          this.cookieService.set('USR_EmployeeInfo_ID', data.USR_EmployeeInfo_ID,1,'/');
          this.cookieService.set('NickName', data.NickName,1,'/');
          this.cookieService.set('PhotoURL', data.PhotoURL,1,'/');
          this.cookieService.set('ORG_Company_ID', data.ORG_Company_ID,1,'/');
          this.cookieService.set('CompanyName', data.CompanyName,1,'/');
          this.cookieService.set('USR_POSEmployeeInfo_ID', data.USR_POSEmployeeInfo_ID,1,'/');
          
          this._router.navigate(['/Home']); //WEB首頁 
        }
        //2024.02.20 新增登入的loading介面
        this.loadingSpiner = false;
      },
      error: error => {
        console.error('There was an error!', error);
        //2024.02.20 新增登入的loading介面
        this.loadingSpiner = false;
      }
    })
  }
}



export class user {
  loginType: string = '2';
  CompanyCode: string = '';
  StoreNumber: string = '';
  Cellphone: string = '';
  Password: string = '';

};
